import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import qs from "query-string";
import { Dropdown, Input, Button, Grid, Form, Modal, Header, Dimmer, Loader, Message } from "semantic-ui-react";
import {
  getSystemAdminUsers,
  submitSystemAdminUpdateAdminStatus,
  submitSystemAdminDelete,
  submitSystemAdminBatchAdmin,
} from "../../actions";
import CommonUtility from "../../utils/CommonUtility";
import { USER_ROLES, USER_TYPE } from "../../constants";

import SysadminAdminTable from "../../component/sysadmin/admin/admin_list_table";

const filterOptions = [
  { key: "name", text: "Name", value: "name" },
  { key: "nric", text: "NRIC", value: "nric" },
  { key: "loginId", text: "Login ID", value: "loginId" },
  { key: "email", text: "Email", value: "email" },
];

const memberOptions = [
  { key: "a", text: "All", value: "all" },
  { key: "e", text: "Employee", value: "e" },
  { key: "d", text: "Dependent", value: "d" },
];

class SysadminAdminListPage extends Component {
  state = {
    currentPage: 1,
    perPage: 10,
    totalPage: 1,
    totalData: 1,
    isShowNextButton: true,
    isLoading: false,
    filter: "name",
    query: "",
    memberType: "all",
    isFromCompany: false,
    companyName: "",
    uploadSuccessMsg: "",
    uploadSuccessList: [],
    uploadFailList: []
  };

  componentDidMount() {
    const { clientId } = this.props.match.params;
    if (this.props.user) {
      const { accessToken } = this.props.user;
      if (accessToken) {
        const query = qs.parse(this.props.location.search);
        let newState = {};
        if (query.page && query.v) {
          newState = {
            currentPage: parseInt(query.page),
            perPage: parseInt(query.v),
          };
        }
        if (query.filter && query.query) {
          newState = {
            ...newState,
            filter: query.filter,
            query: query.query,
          };
        }
        if (query.m) {
          newState = {
            ...newState,
            memberType: query.m,
          };
        }
        this.setState({ ...newState }, () => {
          this.getUsers();
        });
      }
    }
    console.log("check prosp.clients", clientId);
    if (clientId && this.props.clients) {
      let clientData = this.props.clients.find(
        (client) => client._id == clientId
      );
      console.log("check prosp.clients", clientData);
      this.setState({
        isFromCompany: true,
        companyName: clientData ? clientData.name : "",
      });
    }
  }

  getUsers = () => {
    const { accessToken } = this.props.user;
    const { clientId } = this.props.match.params;

    let params = {};

    // if (clientId) {
    //   params.companyId = clientId;
    //   params.fromClientUserPage = true;
    // }

    if (this.state.query !== "") {
      params[this.state.filter] = this.state.query;
    }

    if (this.state.memberType !== "all") {
      params.withMemberType = this.state.memberType;
    }

    params.withUserType = "sys-admin";
    this.setState({ isLoading: true }, () => {
      this.props.getSystemAdminUsers(
        {
          accessToken,
          searchPage: this.state.currentPage,
          searchMax: this.state.perPage,
          params,
        },
        (result, error) => {
          if (result && result.data && result.data.pagination) {
            this.setState({
              totalPage: result.data.pagination.totalPage,
              totalData: result.data.pagination.totalData,
              isLoading: false,
            });
            let countNext = this.state.perPage * this.state.currentPage;
            console.log("check countNext", countNext);
            if (countNext < result.data.pagination.totalData) {
              this.setState({
                isShowNextButton: true,
              });
            } else {
              this.setState({
                isShowNextButton: false,
              });
            }
          }
        }
      );
    });
  };

  setParams = () => {
    let params = `page=${this.state.currentPage}&v=${this.state.perPage}`;
    if (this.state.query !== "") {
      params =
        params + `&filter=${this.state.filter}&query=${this.state.query}`;
    }
    if (this.state.memberType !== "all") {
      params = params + `&m=${this.state.memberType}`;
    }
    this.props.history.push({
      search: params,
    });
  };

  goToPreviousPage = () => {
    if (this.state.currentPage > 1) {
      this.setState({ currentPage: this.state.currentPage - 1 }, () => {
        this.setParams();
        this.getUsers();
      });
    }
  };

  goToNextPage = () => {
    if (this.props.users.length >= this.state.perPage) {
      this.setState({ currentPage: this.state.currentPage + 1 }, () => {
        this.setParams();
        this.getUsers();
      });
    }
  };

  setPage = (num) => {
    this.setState({ currentPage: num }, () => {
      this.setParams();
      this.getUsers();
    });
  };

  setPerPage = (num) => {
    this.setState({ perPage: num, currentPage: 1 }, () => {
      this.setParams();
      this.getUsers();
    });
  };

  onMemberDropdownChange = (e, { value }) => {
    this.setState({ memberType: value, currentPage: 1 }, () => {
      this.setParams();
      this.getUsers();
    });
  };

  onFilterDropdownChange = (e, { value }) => {
    this.setState({ filter: value });
  };

  submitFilter = () => {
    if (this.state.query !== "") {
      this.setState({ ...this.state, currentPage: 1 }, () => {
        this.setParams();
        this.getUsers();
      });
    }
  };

  clearFilter = () => {
    this.setState({ filter: "name", query: "", memberType: "all" }, () => {
      this.props.history.push({
        search: `page=${this.state.currentPage}&v=${this.state.perPage}`,
      });
      this.getUsers();
    });
  };

  checkClearFilter = (e) => {
    if (e.target.value == "") {
      this.setState({ filter: "name", query: "", memberType: "all" }, () => {
        this.props.history.push({
          search: `page=${this.state.currentPage}&v=${this.state.perPage}`,
        });
        this.getUsers();
      });
    }
    this.setState({ query: e.target.value });
  };

  terminateAdmin = (userId, status) => {
    console.log(userId)
    let dataToSend = {
      accesstoken: this.props.user.accessToken,
      userId,
      data: {
        status: status,
      },
    };
    this.props.submitSystemAdminUpdateAdminStatus(
      dataToSend,
      (result, error) => {
        if (result) {
          this.getUsers();
        }
        if (error) {
          this.setState({
            successSubmit: false,
            successMsg: "",
            errorMsg: error.errorMessage,
          });
        }
      }
    );
  };

  deleteAdmin = (userId) => {
    console.log(userId)
    let dataToSend = {
      accesstoken: this.props.user.accessToken,
      userId
    };
    this.props.submitSystemAdminDelete(
      dataToSend,
      (result, error) => {
        if (result) {
          this.getUsers();
        }
        if (error) {
          this.setState({
            successSubmit: false,
            successMsg: "",
            errorMsg: error.errorMessage,
          });
        }
      }
    );
  };

  uploadAdminBatchFile = (e) => {
    this.setState({ isUploadLoading: true })
    submitSystemAdminBatchAdmin(this.props.user.accessToken, e, (cb, err) => {
      this.setState({ isUploadLoading: false })
      if (cb && cb.message) this.setState({ uploadSuccessMsg: cb.message, uploadSuccessList: cb.userList, uploadFailList: cb.errorUser })
    })
  }

  render() {
    const { clientId } = this.props.match.params;
    const isAdminOperation =
      CommonUtility.haveUserType(USER_TYPE.SYS_ADMIN, this.props.user) &&
      CommonUtility.haveRoles([USER_ROLES.ADMIN_OPERATION], this.props.user);
    const isAdminCreation = CommonUtility.haveUserType(USER_TYPE.SYS_ADMIN, this.props.user) &&
      CommonUtility.haveRoles([USER_ROLES.ADMIN_CREATION], this.props.user)
    console.log(this.props.users)
    const isAdminIT = CommonUtility.haveUserType(USER_TYPE.SYS_ADMIN, this.props.user) &&
    CommonUtility.haveRoles([USER_ROLES.ADMIN_IT], this.props.user)

    return (
      <>
        <Grid columns="equal">
          <Grid.Column>
            {(isAdminIT || isAdminCreation) && (
              <>
                <Button
                  as={Link}
                  to={`/systemadmin/admin/create`}
                  color="blue"
                  icon="plus"
                  content="Add new admin"
                />
                <Button onClick={() => this.setState({ uploadAdminModal: true }) } color="blue" icon="upload" content="Upload user"/>
                <Modal size='large' open={this.state.uploadAdminModal}>
                  <Header style={{ backgroundColor: "#2185d0", color: "#FFFFFF" }}>
                      Upload Admin File
                      <span 
                          style={{
                              display:"inline-block", 
                              float:"right", 
                              cursor:"pointer"
                          }} 
                          onClick={
                              () => this.setState({ 
                                uploadAdminModal: false,
                              })}
                          >
                              X
                      </span>
                  </Header>
                  <Modal.Content>
                    <Dimmer.Dimmable>
                      <Dimmer active={this.state.isUploadLoading} inverted>
                          <Loader />
                      </Dimmer>
                      {
                        !this.state.isUploadLoading ?
                            <Grid.Column>
                              <Message color="blue">
                                  <Message.Header>Important Notice</Message.Header>
                                  <p>
                                      Available option for column ROLES are <b>ADMIN_OPERATION, ADMIN_ACCOUNT, ADMIN_CLAIM, ADMIN_CALL_CENTRE, ADMIN_IT, ADMIN_CREATION</b>.
                                      Available option for column GROUP_CODE are <b>ALL, P2, P3, OC, P9, MG, GE, MA, IC, P7</b>. Default is <b>ALL</b>. <br />
                                      Download file below as template, do not edit first ROW.
                                  </p> 
                                      <Button as='a' href="/static/media/BATCH_ADMIN_SAMPLE.xlsx" content="Download Example"/>
                              </Message>
                              <Button as='div' labelPosition='right' onClick={() => this.inputFileAdmin.click()} color="blue" icon="upload" content="Upload user"/>
                              <input
                                  ref={element => this.inputFileAdmin = element}
                                  hidden
                                  onChange={(e)=>this.uploadAdminBatchFile(e.target.files[0])}
                                  type="file"
                              />
                              {
                                this.state.uploadSuccessMsg && this.state.uploadSuccessList.length ? 
                                <Message positive>
                                    <Message.Header>{this.state.uploadSuccessMsg || "Admin Created Successfully!"}</Message.Header>
                                </Message> : <></>
                              }
                              {
                                this.state.uploadFailList.length ? 
                                <Message negative>
                                    <Message.Header>{`${this.state.uploadFailList.length} Admin Failed To Create!`}</Message.Header>
                                    <Message.Content>
                                      {
                                        this.state.uploadFailList.map(failedUser => (
                                          <li>{failedUser.email}</li>
                                        ))
                                      }
                                    </Message.Content>
                                </Message> : <></>
                              }
                            </Grid.Column>
                        : null
                      }
                    </Dimmer.Dimmable>
                  </Modal.Content>
                </Modal>
                {/* <Button as={Link} to="/systemadmin/user/upload" color="blue" icon="upload" content="Upload user"/> */}
              </>
            )}
          </Grid.Column>
          {this.state.isFromCompany == true && (
            <Grid.Column width={3}>
              <Dropdown
                fluid
                placeholder="Member Type"
                selection
                options={memberOptions}
                value={this.state.memberType}
                onChange={this.onMemberDropdownChange}
              />
            </Grid.Column>
          )}

          <Grid.Column width={8}>
            <Form>
              <Input fluid type="text" placeholder="Search..." action>
                <input
                  value={this.state.query}
                  onChange={(e) => this.checkClearFilter(e)}
                />
                <Dropdown
                  placeholder="Filter by"
                  selection
                  options={filterOptions}
                  value={this.state.filter}
                  onChange={this.onFilterDropdownChange}
                />
                <Button
                  type="submit"
                  color="green"
                  icon="search"
                  content="Search"
                  onClick={this.submitFilter}
                />
                {this.state.query.length > 0 && (
                  <Button
                    type="button"
                    color="black"
                    icon="close"
                    content="Clear"
                    onClick={this.clearFilter}
                  />
                )}
              </Input>
            </Form>
          </Grid.Column>
        </Grid>
        {this.state.companyName != "" && (
          <div
            style={{
              marginTop: "20px",
              marginBottom: "20px",
              fontSize: "15px",
            }}
          >
            Company Name: &nbsp;
            <b>{this.state.companyName}</b>
          </div>
        )}

        <SysadminAdminTable
          isLoading={this.state.isLoading}
          users={this.props.users}
          adminPage={true}
          currentPage={this.state.currentPage}
          isShowNextButton={this.state.isShowNextButton}
          perPage={this.state.perPage}
          deleteAdmin={this.deleteAdmin}
          terminateAdmin={this.terminateAdmin}
          totalPage={this.state.totalPage}
          totalData={this.state.totalData}
          setPage={(num) => this.setPage(num)}
          setPerPage={(num) => this.setPerPage(num)}
          goToPreviousPage={() => this.goToPreviousPage()}
          goToNextPage={() => this.goToNextPage()}
          paginationHandler={this.paginationHandler}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
    users: state.systemAdmin.users,
    clients: state.systemAdmin.clients,
  };
};

export default connect(mapStateToProps, {
  getSystemAdminUsers,
  submitSystemAdminUpdateAdminStatus,
  submitSystemAdminDelete,
})(withRouter(SysadminAdminListPage));
